import API from "../Services/API";
import { toQueryString } from "../Services/helpers";
import Model from "./Model";
import State from "./State";

const useRounds = (search, alwaysRefresh) => {
    const searchStr = toQueryString(search);
    return Model({
        alwaysRefresh,
        stateKey: ['rounds', searchStr],
        fetchData: () => API.get('/rounds?'+searchStr),
        returnDataKey: 'rounds',
        defaultLoadingError: 'Failed to load rounds.',
        saveAdditionalData: (rounds) => {
            rounds.forEach(round => {
                State.putIfNotExists(['round', round.id], round)
            })
        }
    });
}

const useClosest = (coords, alwaysRefresh) => {
    const searchStr = toQueryString(coords);
    return Model({
        block: !coords,
        alwaysRefresh,
        stateKey: ['rounds', 'closest', searchStr],
        fetchData: () => API.get('/rounds/closest?'+searchStr).catch(() => null),
        returnDataKey: 'closest',
        defaultLoadingError: 'Failed to load closest round.',
    });
}

const useRound = (roundId, alwaysRefresh, include = '') => {
    return Model({
        alwaysRefresh,
        stateKey: ['round', roundId, include].filter(Boolean), // Remove empty string
        fetchData: () => API.get(`/rounds/${roundId}?include=${include}`),
        returnDataKey: 'round',
        defaultLoadingError: 'Failed to load round.',
        registerAdditionalMethods: (opts) => {
            return {
                schedule: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post(`/rounds/${roundId}/schedule`, data),
                        'Round scheduled',
                        true,
                    );
                },
                markAsDone: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post(`/rounds/${roundId}/markAsDone`, data),
                        'Round marked as done',
                        true,
                    );
                },
                optimise: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post(`/rounds/${roundId}/optimise`, data),
                        null,
                        true,
                    );
                },
                reorder: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post(`/rounds/${roundId}/reorder`, data),
                        'Round order updated',
                        true,
                    );
                },
            }
        },
    });
}

const useJobs = (roundId, alwaysRefresh, include = 'customer', block) => {
    return Model({
        block,
        alwaysRefresh,
        stateKey: ['round', roundId, 'jobs', include],
        fetchData: () => API.get('/rounds/' + roundId + '/jobs?include=' + include),
        returnDataKey: 'jobs',
        defaultLoadingError: 'Failed to load round jobs.',
    });
}

const useStats = (alwaysRefresh) => {
    return Model({
        alwaysRefresh,
        stateKey: ['round', 'stats'],
        fetchData: () => API.get('/rounds/stats'),
        returnDataKey: 'stats',
        defaultLoadingError: 'Failed to load round stats.',
    });
}

export {
    useRounds,
    useClosest,
    useRound,
    useJobs,
    useStats,
};
